<template>
  <div class="d-flex justify-content-between align-items-center">
    <button
      v-if="!hideButtons"
      class="btn btn-light border border-dark fw-bold shadow-sm"
      :disabled="getCurrentStepIndex === 0"
      @click="goToStep({ direction: -1 })"
    >
      <i class="bi bi-arrow-left me-1"></i> Previous
    </button>

    <div
      :class="{
        'w-50': !hideButtons,
        'w-100': hideButtons
      }"
    >
      <ProgressBar />
    </div>

    <button
      v-if="!hideButtons"
      class="btn btn-light border border-dark fw-bold shadow-sm"
      :disabled="getCurrentStepIndex >= getTotalSteps - 1 || !checkStepAnswer()"
      @click="goToStep({ direction: 1 })"
    >
      Next <i class="bi bi-arrow-right ms-1"></i>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProgressBar from "@/components/activity/ProgressBar.vue";

export default {
  name: "StepController",
  components: { ProgressBar },
  data() {
    return {};
  },
  props: {
    hideButtons: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getCurrentStepIndex", "getTotalSteps", "checkStepAnswer"])
  },
  methods: {
    ...mapActions(["goToStep"])
  }
};
</script>
